import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ph_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem("ph_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    if (err.response?.status === 403 && String(err.response?.data?.detail || "").includes("mot de passe provisoire")) {
      if (window.location.pathname !== "/changer-mot-de-passe") window.location.href = "/changer-mot-de-passe";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Une erreur est survenue";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function clean(params) {
  return Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== "" && v !== null && v !== undefined));
}

export async function download(path, params, filename) {
  const r = await api.get(path, { params: clean(params), responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

const nf = (d) => new Intl.NumberFormat("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });
export const fNum = (v, d = 0) => (v === null || v === undefined ? "—" : nf(d).format(v));
export const fEur = (v, d = 2) => (v === null || v === undefined ? "—" : `${nf(d).format(v)} €`);
export const fKm = (v) => (v === null || v === undefined ? "—" : `${nf(0).format(v)} km`);
export const fDate = (s) => (s ? s.slice(0, 10).split("-").reverse().join("/") : "—");
export const fMonth = (s) => {
  if (!s) return "";
  const [y, m] = s.split("-");
  return `${["janv", "févr", "mars", "avr", "mai", "juin", "juil", "août", "sept", "oct", "nov", "déc"][+m - 1]} ${y.slice(2)}`;
};
export const todayIso = () => new Date().toISOString().slice(0, 10);
